import * as React from 'react';


export type FormContextProps<S> = {
	isFetching: boolean;
	getFormObject: () => S;
	setFormObject: (formObject: S) => void;
	addValidationRule: (rule: ValidationRule<S>) => void;
	removeValidationRule: (rule: ValidationRule<S>) => void;
	getErrorValidationRule: () => ValidationRule<S>;
	sortValidationRulesByPriority: (rule: ValidationRule<S>) => void;
	submitForm: () => void;
	validateForm: (formObject: S, cb: (isValid: boolean) => void) => void;
	scrollContainer?: HTMLElement | null;
}

export type ValidationRule<S = any> = {
	code?: string;
	errorText: string;
	isAsync?: boolean;
	fn: (formObject: S) => boolean | Promise<boolean>;
}

export type BaseInput = {
	value: string;
	onChange: (e: React.SyntheticEvent, value?: string, ...rest) => void;
}

export type FormInput<S> = {
	name: string | Array<string>;
	enableOnChangeValidation?: boolean;
	validationRules?: Array<ValidationRule<S>>;
	required?: boolean;
	disableSetFullObject?: boolean;
} & Partial<BaseInput>

const FORM_CONSTANTS = {
	REQUIRED: {
		code: 'REQUIRED',
		errorText: 'Это обязательное поле'
	}
};

const FormContext = React.createContext(null);

function useForm<S>(): () => FormContextProps<S> {
	return () => React.useContext(FormContext);
}

function getValueByName(name: string | Array<string>, formObject: any): any {
	return typeof name === 'string'
		? formObject[name]
		: Array.isArray(name) && getFormValueByNameRoute(name as Array<string>, formObject);
}

function setValueByName(value: any, name: string | Array<string>, formObject: any): any {
	if (typeof name === 'string') {
		formObject[name] = value;
	} else if (Array.isArray(name)) {
		setFormValueByNameRoute(value, name, formObject);
	}
}

function getFormValueByNameRoute(nameRoute: Array<string> = [], formObject = {}) {
	return nameRoute.reduce((acc, partName) => acc && acc[partName] || '', formObject);
}

function setFormValueByNameRoute(value: any, nameRoute: Array<string> = [], formObject = {}) {
	let obj = formObject;

	nameRoute.forEach((partName, idx, arr) => {
		if (idx === arr.length - 1) {
			obj[partName] = value;
			return;
		}

		obj = obj[partName] || {};
	});
}

export {
	FORM_CONSTANTS,
	FormContext,
	useForm,
	getValueByName,
	setValueByName,
	getFormValueByNameRoute,
	setFormValueByNameRoute,
};
